import React, { useContext, useEffect, useState } from "react";
// styled components
import { Row, Col, Table, Empty, Button, Divider, Input, Select } from "antd";
import { Dropdown, Icon } from "semantic-ui-react";
// hooks
import { useGestionarPostulaciones } from "../../../../hooks/useGestionarPostulaciones";

// components
import { ModalVerPropuesta } from "./components/ModalVerPropuesta";
// icons
import { LeftOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
// data select
import {
  cantidadRegistros,
  LineaEstrategicaOptions,
  EstadosPostulacion,
} from "../../../../utils/dataSelectOptions";

import "../../Convocatorias/old.scss";
import "./../GestionarPostulaciones/gestionarPostulaciones.scss";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { HomeFilled } from "@ant-design/icons";
import { ModalExportacion } from "../../../../components/Administrador/ModalExportacion/ModalExportacion";
import { ModalCodigos } from "../../../../components/Administrador/ModalCodigos/ModalCodigos";
import { ModalActualizar } from "../../../../components/Administrador/ModalCodigos/ModalActualizar";
import { ModalTipos } from "../../../../components/Administrador/ModalTipos/ModalTipos";
import { ModalEstado } from "../../../../components/Administrador/ModalEstado/ModalEstado";
import { ModalInformacion } from "../../../../components/Administrador/ModalInformacion/ModalInformacion";
import { useMaestras } from "../../../../hooks/useMaestras";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { TemplateContext } from "../../../../utils/template_context";
import { generarAnios } from "../../../../utils/generateYears";
import getStorageUser from "../../../../middlewares/GetStorageUser"

import userEvent from "@testing-library/user-event";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import apiPostulaciones from "../../../../api/Postulaciones/api-postulaciones";

const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
  "Anulado": "#0051E6",
  "Evaluado": "#6435C9",
  "Por evaluar": "#F28C02",
};
const TiposIdentificacion: any = {
  "1": "Persona Natural",
  "3": "Grupo Conformado",
  "2": "Persona Juridica",
};

const TipoDocumento: any = {
  "1": "CC",
  "3": "CC",
  "2": "NIT",
}

export const GestionarPostulaciones = () => {
  let {
    allpostulaciones,
    setAllPostulaciones,
    cargarTodasPostulaciones,
    modal,
    VerPropuesta,
    AceptarModalPropuesta,
    CancelarModal,
    postulacion,
    descargarArchivo,
    totalregistros,
    totalregistrosInscritos,
    totalregistrosAnulados,
    totalregistrosCompletar,
    totalregistrosEvaluado,
    totalregistrosPorevaluar,
    totalregistrosSubsanado,
    totalregistrosSubsanar,
    totalregistrosAceptado,
    totalregistrosRechazado,
    cantidadpáginas,
    cambiarCantidadPaginas,
    // categorias,
    lineasconvocatoria,
    obtenerCategoriasLineas,
    obtenerLineasConvocatorias,
    filtros,
    setFiltros,
    limpiarFiltros,
    buscarpostulaciones,
    loading
  } = useGestionarPostulaciones();
  const context = useContext(TemplateContext);

  const { obtenerLineaConvocatorias, lineaConvocatorias } = useMaestras();
  const [participante, setParticipante] = useState();
  const [countSubsanable, setCountSubsanable] = useState<number>(0);
  const [idPostulacion, setIdPostulacion] = useState<number>();
  const [observaciones, setObservaciones] = useState<any>(null);
  const [years, setYears] = useState<any>([]);
  const [user, setUser] = useState<any>({});

  const generateOptionsYears = () => {
    let arrayYears = [];
    const years = generarAnios();

    if (years.length > 0) {
      years.map((year, i) => { arrayYears.push({ key: i, value: year, text: year }) });
    }

    setYears(arrayYears);
  }
  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
    generateOptionsYears();
    // cargarTodasPostulaciones(false, "general");
    // obtenerLineasConvocatorias();
    obtenerCategoriasLineas();
    obtenerLineaConvocatorias();
  }, []);

  useEffect(() => {
    // Este useEffect asegurará que el estilo de scroll se mantenga
    const scrollableDiv = document.querySelector('.my-scrollable-div') as HTMLElement;
    if (scrollableDiv) {
      scrollableDiv.style.overflowX = 'auto';
      scrollableDiv.style.whiteSpace = 'nowrap';
    }
  }, []);

  function itemRenderTable(current: any, type: any, originalElement: any) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  }
  const columns: any = [
    {
      title: "No.",
      width: 40,
      fixed: context.device === "lg" ? "left" : false,
      key: "index",
      render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
    },
    {
      title: "Nombre de proyecto",
      width: 300,
      fixed: context.device === "md" ? "left" : false,
      render: (data: any) =>
      <span style={{whiteSpace: "pre-line"}}>
        {data?.nombre_propuesta}
      </span>,
    },
    {
      title: "Código",
      width: 80,
      render: (data: any) => <span>{data?.radicado}</span>,
    },
    {
      title: "Estado",
      key: "estado",
      width: 150,
      render: (data: any) =>
      <span style={{ color: coloresEstado[data?.estado] }}>
        {data?.estado == 'Sin revisar' ? 'Inscrito sin revisar' : data?.estado}
      </span>,
    },
    {
      title: "Linea convocatoria",
      ellipsis: true,
      width: 300,
      render: (data: any) => {
        return <span style={{whiteSpace: "pre-line"}}>{data?.linea_convocatoria}</span>;
      },
    },
    {
      title: "Categoría",
      width: 150,
      render: (datos: any) => {
        return (
          <>
            <span style={{whiteSpace: "pre-line"}}>{datos.categoria_linea_convocatoria}</span>
          </>
        );
      },
    },
    {
      title: "Tipo Documento",
      width: 140,
      render: (datos: any) => {
        return (
          <>
            <span>{TipoDocumento[datos.tipo_participante]}</span>
          </>
        );
      },
    },
    {
      title: "Nro. Documento",
      width: 100,
      render: (datos: any) => {
        return (
          <>
            <span>{datos.numero_documento_participante}</span>
          </>
        );
      },
    },
    {
      title: "Creado por",
      width: 200,
      render: (datos: any) => {
        return (
          <>
            <span style={{whiteSpace: "pre-line"}}>{datos.nombre_representante}</span>
          </>
        );
      },
    },
    {
      title: "Fecha de creación",
      width: 100,
      render: (datos: any) => {
        return (
          <>
            <span>{datos.fecha_creacion}</span>
          </>
        );
      },
    },
    /*{
      title: "Actualizado por",
      width: 100,
      render: (datos: any) => {
        return (
          <>
            <span>{}</span>
          </>
        );
      },
    },
    {
      title: "Fecha Actualización",
      width: 100,
      render: (datos: any) => {
        return (
          <>
            <span>{datos.fecha_actualizacion}</span>
          </>
        );
      },
    },*/
    {
      title: () => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Acciones
          </Col>
        </Row>
      ),
      width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <>
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              <Button
                onClick={() => {
                  setIdPostulacion(datos.id_postulacion)
                  VerPropuesta(datos)
                }}
                className="no-margin button-azul-ghost font-family-Montserrat-Medium"
              >
                Ver Más
              </Button>
            </Col>
          </Row>
        </>
      ),
    },
  ];
  const routes = [{ nombre: "Postulaciones" }, { nombre: "Artistas" }];

  /* **** MODAL **** */
  const opcionesSelect = [
    { id: 1, nombre: "Aceptados", value: "Aceptado" },
    { id: 2, nombre: "No Aceptados", value: "Rechazado" },
    { id: 3, nombre: "Todos los postulados", value: "Todos" }
  ];

  const [openModal, setOpenModal] = useState(false);
  const [openModalCodigos, setOpenModalCodigos] = useState(false);
  const [openActualizarCodigos, setOpenActualizarCodigos] = useState(false);
  const [openModalTipo, setopenModalGestionarTipoP] = useState(false);
  const [openModalEstado, setopenModalGestionarEstado] = useState(false);
  const [openModalInformacion, setopenModalInformacion] = useState(true);

  const openModalExportar = () => setOpenModal(true);
  const openModalGestionarCodigos = () => setOpenModalCodigos(true);
  const openModalModalActualizar = () => setOpenActualizarCodigos(true);
  const openModalGestionarTipoP = () => setopenModalGestionarTipoP(true);
  const openModalGestionarEstado = () => setopenModalGestionarEstado(true);
  


  const [categorias, setCategorias] = useState([]);
  const handleLineaChange = async (id_linea: number | string) => {
    if (typeof id_linea === 'string') {
      // Convierte la cadena a número si es necesario
      id_linea = parseInt(id_linea, 10);
    }

    try {
      const { data } = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
      setCategorias(data);
      setFiltros({
        ...filtros,
        categoria: null,
        linea_estrategica: id_linea,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="background-color-F7FBFF h-100">
        <BreadCrumbAdmin routes={routes} />
        <div className="container-fluid ps-md-4 pe-md-4 main-c">
          <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
            Gestionar postulación de proyectos
          </div>

          <div className="sombra_card" style={{ marginBottom: "20px" }}>
            <div>
              <div className="header_card">
                <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                  Filtrar postulaciones
                </div>
              </div>
              <div className="body_card">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3">
                    <div className="row">
                      <div className="col-12 pb-2">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar por palabra
                        </span>
                      </div>
                      <div className="col-12 pb-2">
                        <Input
                          value={filtros.buscarpalabra}
                          suffix={
                            <SearchOutlined className="font-color-051923bf" />
                          }
                          onChange={(e) =>
                            setFiltros({
                              ...filtros,
                              buscarpalabra: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                    <div className="row mb-3">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar línea
                        </span>
                      </div>
                      <div className="col-12">
                        {user.documento != '1152210452' && user.documento != '1128407398' && (
                          <Select
                              showSearch
                              value={filtros.linea_estrategica}
      //                        allowClear
                              optionFilterProp="children"
                              style={{ width: "100%" }}
                              placeholder="Seleccionar..."
                              onChange={(value: any) => handleLineaChange(value)}
                          >
                              {lineaConvocatorias.slice().reverse().filter(({ nombre }: any) => !nombre.includes('- SM') && !nombre.includes('- MCM')).map(({ id, nombre }: any) => (
                                <Select.Option key={id} value={id}>{nombre}</Select.Option>
                              ))}
                          </Select>
                        )}
                        {user.documento == '1152462177' && (
                          <Select
                            showSearch
                            value={filtros.linea_estrategica}
    //                        allowClear
                            optionFilterProp="children"
                            style={{ width: "100%" }}
                            placeholder="Seleccionar..."
                            onChange={(value: any) => handleLineaChange(value)}
                          >
                            {lineaConvocatorias.slice().reverse().map(({ id, nombre }: any) => (
                              <Select.Option key={id} value={id}>
                                {nombre}
                              </Select.Option>
                            ))}
                          </Select>
                        )}
                        {user.documento == '1152210452' && (
                          <Select
                            showSearch
                            value={filtros.linea_estrategica}
    //                        allowClear
                            optionFilterProp="children"
                            style={{ width: "100%" }}
                            placeholder="Seleccionar..."
                            onChange={(value: any) => handleLineaChange(value)}
                          >
                            {lineaConvocatorias.slice().reverse().filter(({ nombre }: any) => nombre.includes('- MCM')).map(({ id, nombre }: any) => (
                              <Select.Option key={id} value={id}>{nombre}</Select.Option>
                            ))}
                          </Select>
                        )}
                        {user.documento == '1128407398' && (
                          <Select
                            showSearch
                            value={filtros.linea_estrategica}
    //                        allowClear
                            optionFilterProp="children"
                            style={{ width: "100%" }}
                            placeholder="Seleccionar..."
                            onChange={(value: any) => handleLineaChange(value)}
                          >
                            {lineaConvocatorias.slice().reverse().filter(({ nombre }: any) => nombre.includes('- SM')).map(({ id, nombre }: any) => (
                              <Select.Option key={id} value={id}>{nombre}</Select.Option>
                            ))}
                          </Select>
                        )}
                      </div>
                    </div>
                  {/*
                  <div className="col-12 col-md-6 col-lg-2">
                    <div className="row">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar categoría
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={(value: any, option: any) =>
                            setFiltros({ ...filtros, categoria: option.children })
                          }
                        >
                          {categorias.map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={id}>
                              {nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <div className="row">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar estado
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={(value: any) =>
                            setFiltros({ ...filtros, estado: value })
                          }
                        >
                          {EstadosPostulacion.map(({ value, text }) => (
                            <Select.Option key={value} value={value}>
                              {text}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <div className="row">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar Año
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          options={years}
                          onChange={(value: any) =>
                            setFiltros({ ...filtros, anio: value })
                          }
                        >
                        </Select>
                      </div>
                    </div>
                  </div>
                  */}
                </div>
              </div>
            </div>

            <div className="footer_card justify-content-flex-end">
              <Button
                className="button-azul-ghost m-0"
                onClick={limpiarFiltros}
              >
                Limpiar Filtros
              </Button>
              <Button
                className="button-azul-radius m-0"
                onClick={buscarpostulaciones}
              >
                Buscar
              </Button>
            </div>
          </div>

          <div className="row-shadow">
            <div className="my-scrollable-div col-12 col-md-12 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3" style={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '100%', fontSize: 'small' }}>
              <div className="d-flex justify-content-end mx-3 font-color-0051E6">
                Anulado :{" "}
                  <span className="font-color-0051E6">{totalregistrosAnulados}</span>
              </div>
              <div className="d-flex justify-content-end mx-2">
                Por completar :{" "}
                  <span className="font-color-black">{totalregistrosCompletar}</span>
              </div>
              <div className="d-flex justify-content-end mx-2 font-color-6435C9">
                Evaluado :{" "}
                  <span className="font-color-6435C9">{totalregistrosEvaluado}</span>
              </div>
              <div className="d-flex justify-content-end mx-2 font-color-F28C02">
                Por evaluar :{" "}
                  <span className="font-color-F28C02">{totalregistrosPorevaluar}</span>
              </div>
              <div className="d-flex justify-content-end mx-2 font-color-DB2828">
                Rechazado :{" "}
                  <span className="font-color-DB2828">{totalregistrosRechazado}</span>
              </div>
              <div className="d-flex justify-content-end mx-2 font-color-6435C9">
                Subsanado :{" "}
                  <span className="font-color-6435C9">{totalregistrosSubsanado}</span>
              </div>
              <div className="d-flex justify-content-end mx-2 font-color-F28C02">
                Subsanar :{" "}
                  <span className="font-color-F28C02">{totalregistrosSubsanar}</span>
              </div>
              <div className="d-flex justify-content-end mx-2">
                Inscritos sin revisar :{" "}
                  <span className="font-color-black">{totalregistrosInscritos}</span>
              </div>
              <div className="d-flex justify-content-end mx-2 font-color-00904C">
                Aceptado :{" "}
                  <span className="font-color-00904C">{totalregistrosAceptado}</span>
              </div>
              <div className="d-flex justify-content-end">
                Total :{" "}
                  <span className="font-color-F28C02">{totalregistros}</span>
              </div>
              <div
                className="d-flex justify-content-end registos-adminconvocatoria"
                style={{ width: 200 }}
              >
                <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                  Registros por página
                </label>
                <Dropdown
                  className="d-flex justify-content-end select-registros-adminconvocatoria no-margin"
                  defaultValue={cantidadpáginas}
                  options={cantidadRegistros}
                  icon={
                    <Icon
                      className="font-color-051923bf iconos-dropdown-global"
                      name="angle down"
                    />
                  }
                  onChange={(e, { value }) =>
                    cambiarCantidadPaginas(e, value)
                  }
                />
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Table
                  className="height-30"
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No se han diligenciados datos para está sección"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  pagination={{
                    position: ["bottomRight"],
                    itemRender: itemRenderTable,
                    pageSize: cantidadpáginas,
                  }}
                  dataSource={allpostulaciones}
                  columns={columns}
                  size="small"
                  bordered={false}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>

        <ModalVerPropuesta
          modal={modal}
          AceptarModal={AceptarModalPropuesta}
          postulacion={postulacion}
          descargarArchivo={descargarArchivo}
          setAllPostulaciones={setAllPostulaciones}
          allpostulaciones={allpostulaciones}
          CancelarModal={CancelarModal}
          lineasConvocatoria={lineasconvocatoria}
          setCountSubsanable={setCountSubsanable}
          countSubsanable={countSubsanable}
          setIdPostulacion={setIdPostulacion}
          idPostulacion={idPostulacion}
          setObservaciones={setObservaciones}
          observaciones={observaciones}
        />
        <Row className="container-sticky-footer" style={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '100%' }}>
          {/* <Col span={12}>
          <Button className="button-blanco-radius">ATRÁS</Button>
        </Col> */}
          {
            user.role_id == 1 ?
            <div>
              <Button className="button-azul-radius" onClick={openModalGestionarTipoP} style={{ marginRight: '5px' }} >
                Gestionar tipo de participantes
              </Button>
              <Button className="button-azul-radius" onClick={openModalGestionarCodigos} style={{ marginRight: '5px' }} >
                Gestionar códigos
              </Button>
              <Button className="button-azul-radius" onClick={openModalModalActualizar} style={{ marginRight: '5px' }} >
                Gestionar códigos nuevos
              </Button>
              <Button className="button-azul-radius" onClick={openModalExportar}>
                Exportar datos
              </Button>
            </div>: <span></span>
          }
        </Row>
      </div>
      {openModal && (
        <ModalExportacion
          openModal={openModal}
          setOpenModal={setOpenModal}
          opcionesSelect={opcionesSelect}
          modulo="Participante"
          consulta="1"
        />
      )}
      {openModalCodigos && (
        <ModalCodigos
          openModal={openModalCodigos}
          setOpenModal={setOpenModalCodigos}
        />
      )}
      {openActualizarCodigos && (
        <ModalActualizar
          openModal={openActualizarCodigos}
          setOpenModal={setOpenActualizarCodigos}
        />
      )}
      {openModalTipo && (
        <ModalTipos
          openModal={openModalTipo}
          setOpenModal={setopenModalGestionarTipoP}
        />
      )}
      {openModalEstado && (
        <ModalEstado
          openModal={openModalEstado}
          setOpenModal={setopenModalGestionarEstado}
        />
      )}
      {openModalInformacion && (
        <ModalInformacion
          openModal={openModalInformacion}
          setOpenModal={setopenModalInformacion}
        />
      )}
    </>
  );
};
